import { useNavigate } from "react-router-dom";
import CarouselHome from "../components/CarouselHome";
import SearchBar from "../components/SearchBar";
import { useState } from "react";
import React from "react";
import { useCookies } from "react-cookie";
import TestLogin from "../models/TestLogin";
import TextHome from "../components/TextHome";
import ChannelsGrid from "../components/ChannelsGrid";
import config from "../config";

export default function HomePage() {
  const navigate = useNavigate();
  const [hasUserGroups, setHasUserGroups] = useState<boolean>(false);
  const [cookies] = useCookies(["userGroups"]);
  const [isLogged, setIsLogged] = useState<boolean>(false);

  React.useEffect(() => {
    (async () => {
      const isLoggedIn = await TestLogin();

      if (isLoggedIn) {
        setIsLogged(true);
        const userGroups = cookies.userGroups ? cookies.userGroups : null;
        const hasGroups =
          userGroups &&
          Array.isArray(userGroups) &&
          userGroups.length > 0 &&
          userGroups.some((group) =>
            config.portalCognitoGroups.includes(group)
          );

        setHasUserGroups(hasGroups);
      }

      if (process.env.REACT_APP_TARGET_ENV == "dev") {
        // for local test
        setIsLogged(true);
        setHasUserGroups(true);
      }
    })();
  }, []);

  function loadSearchPage(keyword, contentType) {
    const parameters = {
      keyword: keyword,
      contentType: contentType,
    };

    navigate("/search", { state: JSON.stringify(parameters) });
  }
  return (
    <div className="my-2">
      {isLogged && hasUserGroups && (
        <SearchBar sourcePage="carousel" onSearch={loadSearchPage} />
      )}
      <CarouselHome idPage={"home"}></CarouselHome>
      {isLogged && hasUserGroups && <ChannelsGrid idPage={"home"} />}
      <TextHome idPage={"home"}></TextHome>
    </div>
  );
}
